module.exports = __webpack_public_path__ + "img/unit3.cd004c67.jpg";